// @noflow
import { HeaderContainer, Subheading, WarningIcon, WiringTitle } from './styles';
import { PhoneNumber, PrimaryBtn, StandardLayout, WaitingIndicator } from '~/components/widgets';
import React, { Component } from 'react';

import { EXCLAMATION } from '~/core/constants/icons/general';
import { FormattedMessage } from 'react-intl';
import messages from './intl';

export default class WiringError extends Component {
    componentWillMount() {
        this.setState({
            refreshing: false,
            showExtendedSupport: false
        });
    }

    refresh = () => {
        const { refresh } = this.props;

        refresh();
        this.setState({
            refreshing: true
        });

        setTimeout(() => {
            this.setState({
                refreshing: false,
                showExtendedSupport: true
            });
        }, 5000);
    };

    render() {
        const { showExtendedSupport, refreshing } = this.state;
        const { phoneNumber } = this.props;
        return (
            <StandardLayout>
                <HeaderContainer>
                    <WarningIcon icon={EXCLAMATION} />
                    <WiringTitle>
                        <FormattedMessage {...messages.title} />
                    </WiringTitle>
                </HeaderContainer>
                <Subheading>
                    <FormattedMessage {...messages.subheading} />
                </Subheading>
                <p>
                    <FormattedMessage {...messages.step1} />
                </p>
                <p>
                    <FormattedMessage {...messages.step2} />
                </p>
                <p>
                    <FormattedMessage {...messages.step3} />
                </p>
                <p>
                    <FormattedMessage {...messages.step4} />
                </p>
                <p>
                    <FormattedMessage {...messages.step5} />
                </p>
                {!showExtendedSupport && (
                    <PrimaryBtn disabled={refreshing} onClick={this.refresh}>
                        <FormattedMessage {...messages.refresh} />
                    </PrimaryBtn>
                )}

                <WaitingIndicator show={refreshing} />

                {showExtendedSupport && (
                    <div>
                        <p>
                            <FormattedMessage {...messages.extendedSupport} />
                        </p>
                        {phoneNumber && (
                            <p className="phone_number">
                                <PhoneNumber phoneNumber={phoneNumber} />
                            </p>
                        )}
                    </div>
                )}
            </StandardLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/wiring-error/component.js